import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'
import { useStepper } from './SurveyFeatureStepper/useStepper'

const ProgressBar: React.FC = () => {
  const { progress: { total, answered } } = useStepper()
  const value = (answered / total) * 100
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: { xs: '100%', md: '50%' }
    }}>
      <LinearProgress variant="determinate" value={value} sx={{ width: '100%', height: 8 }} />
      <Typography fontWeight={'bold'} ml={2}>{value.toFixed()}%</Typography>
    </Box>
  )
}
export default ProgressBar
